export class Maestro_Usuarios {
    id: number;
    login: string;
    nroDocumento: string;
    nombre: string;
    apellidos: string;
    nombresApellidos: string;
    email: string;
    movil: string;
    domicilio: string;
    provincia: string;
    provinciaDescripcion: string;
    ciudad: string;
    ciudadDescripcion: string;
    activo: boolean;
    idRol: number;
    rol: string;
    mostrarRolesAliado: boolean;
}